import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import styles from './../style/CircleCardsSlyder.module.scss'

import { Container, Image, Card, Button } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import FeedbackForm from './FeedbackForm'

class CircleCardsSlyder extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      show_feedback: false,
      feedback_name: ``
    }
  }

  showFeedback = ( name ) => {
    this.setState({ show_feedback: true, feedback_name: name });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { data, title, rtext, className, imageSize, variant } = this.props,
    { show_feedback, feedback_name } = this.state

    return (
      <section className={`${styles.section} ${styles[className]}`}>
        <Container>
          {title != '' &&
            <WhiteBlockTitle
              title={title || ``}
              text={rtext || ``}
            />
          }
          <div className={styles.swiper_container}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                this.setState({ activeIndex: swiper.realIndex })
              }}
              breakpoints={{
                768: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1202: {
                  slidesPerView: 5
                }
              }}
            >
              {data?.list.map((elm, index) => (
                <SwiperSlide key={index}>
                  <Card className={styles.card}>
                    <Card.Img as='div' className={variant == 1 ? styles.card_image : styles.card_image2 }>
                      <div className={styles.card_num}>{this.formatSlideNumber(index)}</div>
                      <Image src={elm?.image} alt={elm?.name} width={imageSize?.width} height={imageSize?.height} />
                    </Card.Img>
                    <Card.Body className={`pt-0`}>
                      <Card.Title className={styles.card_title}>{elm?.name}</Card.Title>
                      <Card.Text>{elm?.text}</Card.Text>
                      <Button onClick={() => { this.showFeedback( elm?.name ) }} as={`div`} variant='light' className={styles.card_btn}>
                        <div className={styles.card_btn_icon}>
                          <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" strokeLinecap="round"/>
                          </svg>
                        </div>
                        <div className={styles.card_btn_name}>Получить каталог</div>
                      </Button>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className={styles.slydenav_btns}>
              <div></div>
              <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                </svg>
              </div>
            </div>
          </div>
        </Container>
        <FeedbackForm
          title={`Получить каталог`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[
            {
              name: `Ручка`,
              value: feedback_name
            }
          ]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

CircleCardsSlyder.propTypes = {
  data: PropTypes.object,
  title: PropTypes.string,
  rtext: PropTypes.string,
  className: PropTypes.string,
  imageSize: PropTypes.object,
  variant: PropTypes.number
}

CircleCardsSlyder.defaultProps = {
  data: {},
  title: ``,
  rtext: ``,
  className: `top-50bottom-10`,
  imageSize: {
    width: 111,
    height: 166
  },
  variant: 1
}

export default CircleCardsSlyder